module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8599/img/map.svg"